module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.bundleProductPreview.title')))]), _vm._v(" "), _c('div', [_c('div', [_c('h3', [_vm._v("\n        " + _vm._s(_vm.$t('static.bundleProductPreview.openProductEdit')) + ": "), _c('router-link', {
    attrs: {
      "to": {
        name: 'productBundles.edit',
        params: {
          id: _vm.productId
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('div', [_c('v-form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "form": _vm.form,
      "translation": "form.bundleProductPreview",
      "hasLabel": true
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('static.bundleProductPreview.bundleProducts')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.products,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sku",
      "label": _vm.$t('static.bundleProductPreview.table.sku'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('static.bundleProductPreview.table.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bundleProductPreview.table.action')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'products.edit',
              params: {
                id: scope.row.id
              }
            },
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('static.bundleProductPreview.view')))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bundle-preview-button"
  }, [_c('el-button', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-193e156b","hasScoped":true}!./src/app/components/bundleProductPreview/bundleProductPreview.html
// module id = 2927
// module chunks = 1